// extracted by mini-css-extract-plugin
export default {"upsellDeclineButton":"UpsellDeclineButton_upsellDeclineButton__OnDn6"};